import {
  Box,
  Flex,
  Text,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from '@chakra-ui/react';

import AccountForm from '../AccountForm/AccountForm';
import BrandForm from '../BrandForm/BrandForm';
import InvitesForm from '../InvitesForm/InvitesForm';

import { useGetUserDataQuery, useGetUsersDataQuery, useGetInvitationsQuery, useGetBrandDataQuery } from '../../Redux/features/auth/authApiSlice';

export default function DashboardSettings() {

  const {
    data: brandData,
    isLoading: isLoadingBrandData,
  } = useGetBrandDataQuery();

  const { data: userData, isLoading: isLoadingUserData } =
    useGetUserDataQuery();

  const { data: usersData, isLoading: isLoadingUsersData } =
    useGetUsersDataQuery();

  const { data: userInvitations, isLoading: isLoadingUserInvitations } =
    useGetInvitationsQuery();

  if (isLoadingBrandData || isLoadingUserData || isLoadingUsersData || isLoadingUserInvitations) {
    return (
      <Box p="5">
        <Text>Cargando datos...</Text>
      </Box>
    );
  }

  return (
    <>

      <Box bg="white" p="5" borderBottom="1px solid #e2e8f0">
        <Flex alignItems="center" justifyContent="space-between">
          <Text fontWeight="bold" fontSize='24px'>Ajustes</Text>
        </Flex>
      </Box>

      <Box p="5">
        <Tabs variant='soft-rounded'>
          <TabList>
            <Tab _selected={{ bg: '#e2e8f0' }} borderRadius={12} mr={2}>Mi usuario</Tab>
            <Tab _selected={{ bg: '#e2e8f0' }} borderRadius={12} mr={2}>Marca</Tab>
            <Tab _selected={{ bg: '#e2e8f0' }} borderRadius={12}>Usuarios</Tab>
          </TabList>

          <TabPanels>
            <TabPanel paddingLeft={2}>
              {userData && <AccountForm userData={userData} />}
            </TabPanel>
            <TabPanel paddingLeft={2}>
              <BrandForm brandData={brandData?.data} />
            </TabPanel>
            <TabPanel paddingLeft={2}>
              <InvitesForm brandData={brandData} usersData={usersData?.data} userInvitations={userInvitations?.data} />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>

    </>
  )
}
